/**
 * 状态管理器 - 用户管理
 *
 * @ version 1.0.0
 **/
import {
  setStore,
  getStore,
  removeStore
} from '../../utils/storage.js'
export default {
  namespaced: true,
  state: {
    isLogin: false, // 登录状态
    userId: '', //用户ID
    userCode: '',
    userType: '',
    loginName: '', //登录账户
    nickName: '', //昵称
    balance: 0, //积分
    avatar: '', //头像
    sex: 0, //性别
    contact: '', //联系人
    mobile: '', //手机号
    email: '', //邮箱
    cert: '', //资质证书
    authFlag: '00',
    status: '0',
    registerIp: '', //注册ip
    loginIp: '', //登录ip
    loginDate: '', //登录日期
    demServType: '', //服务类型
    demLevel: 0,
    demScore: 0,
    demTotalAmount: 0,
    demTotalCount: 0,
    demFinishCount: 0,
    demCompCount: 0,
    desSoftType: '', //擅长的设计软件
    desSoftExtra: '', //擅长的设计软件(其他)
    desTotalAmount: 0,
    desTotalCount: 0,
    desFinishCount: 0,
    desCompCount: 0,
    desLevel: 0,
    desScore: 0,
    desAge: 0,
    createTime:'',
    location:''
  },
  mutations: { //commit
    setUserInfo(state, payload) {
      for (let i in payload) {
        for (let j in state) {
          if (i === j) {
            state[j] = payload[i];
          }
        }
      }
      setStore("userInfo", state);
    }
  },
  actions: { //dispatch
    async login({
      state,
      commit,
      dispatch,
      rootState
    }, data) {
      commit('setUserInfo', data.userInfo);
      state.isLogin = true; // 登录状态
      setStore("userInfo", state);
    },
    async logout({
      state,
      commit,
      rootState
    }) {
      for (let j in state) {
        state[j] = ''
      }
      state.isLogin = false;
      // 从本地缓存中异步移除指定key
      removeStore('userInfo');
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js